import { Controller } from '@hotwired/stimulus'
import { ajaxCall } from '~/plugins/dropdowns/dynamic_dropdown_shared_functions'

export default class extends Controller {
  static targets = [
    'geography',
    'carShare',
    'carDistance',
    'twoWheelsShare',
    'twoWheelsDistance',
    'publicTransportShare',
    'publicTransportDistance',
    'footShare',
    'footDistance',
    'noMeansShare',
    'noMeansDistance'
  ]

  get selectedGeography() {
    return Array.from(this.geographyTarget.options).find(opt => opt.selected).value
  }

  connect() {
    this.element.controller = this
  }

  updateDropdowns() {
    const url = '/commuting_geography'
    const data = {
      selection: this.selectedGeography,
      emission_item_db_name: this.dbNameTarget
    }

    const response = ajaxCall(url, data)

    this.carShareTarget.value = response['car_share']
    this.carDistanceTarget.value = response['car_distance']
    this.twoWheelsShareTarget.value = response['two_wheels_share']
    this.twoWheelsDistanceTarget.value = response['two_wheels_distance']
    this.publicTransportShareTarget.value = response['public_transport_share']
    this.publicTransportDistanceTarget.value = response['public_transport_distance']
    this.footShareTarget.value = response['walking_share']
    this.footDistanceTarget.value = response['walking_distance']
    this.noMeansShareTarget.value = response['no_commuting_share']
    this.noMeansDistanceTarget.value = response['no_commuting_distance']
  }
}
